// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button, input, select, textarea, a.button {
  border-color: var(--color-elevated-border);
  color: var(--color-elevated-draw);
  display: inline-block;
  font-weight: normal;
  line-height: var(--line-height);
  padding: 0 0.6rem;
  border-width: var(--border-width);
  border-style: solid;
  outline: none;
  border-radius: 0;
}

button, a.button {
  background-color: var(--color-elevated-border);
  cursor: default;
  height: calc(var(--line-height) + 2 * var(--border-width));
  -webkit-user-select: none;
  user-select: none;
}
button:disabled, a.button:disabled {
  background-color: var(--color-elevated-canvas);
  opacity: var(--opacity-disabled);
}
button.confirming, a.button.confirming {
  color: var(--color-elevated-warn);
  font-weight: bold;
}

input, select, textarea {
  background-color: var(--color-base-input);
  height: var(--line-height);
}
input:focus, select:focus, textarea:focus {
  background-color: var(--color-elevated-input);
}
input::placeholder, select::placeholder, textarea::placeholder {
  color: var(--color-base-hint);
}

input[type=checkbox], input[type=radio] {
  height: 1rem;
  margin: 0;
  min-width: unset;
  padding: 0;
  vertical-align: middle;
  width: 1.1rem;
}

input[type=number] {
  padding-right: 0.4rem;
}

.chrome input[type=number] {
  padding-right: 0;
}

select:has(option:checked:disabled) {
  color: var(--color-base-hint);
}

fieldset {
  margin: 0;
  padding: 0;
}

fieldset:has(input[type=checkbox]), fieldset:has(input[type=radio]) {
  text-align: right;
}
fieldset:has(input[type=checkbox]) legend.label-text, fieldset:has(input[type=radio]) legend.label-text {
  color: var(--color-elevated-text);
}
fieldset:has(input[type=checkbox]) label:not(:last-of-type), fieldset:has(input[type=radio]) label:not(:last-of-type) {
  margin-right: 2rem;
}

fieldset:has(input[type=radio]) {
  border: var(--border-elevated);
  padding: 0.5rem 1rem;
  text-align: left;
}
fieldset:has(input[type=radio]) legend.label-text {
  text-align: left;
}
fieldset:has(input[type=radio]) label {
  display: block;
}

input[type=checkbox]:disabled, input[type=radio]:disabled {
  opacity: 0.3;
}

label .label-text {
  color: var(--color-base-text);
  display: inline-block;
  text-align: right;
}

label:has(:disabled:not(option)) .label-text {
  opacity: 0.5;
}

label:has(textarea) .label-text {
  position: relative;
  top: calc(0.3rem + 1px);
}

label:has(:checked):not(:has(select)) .label-text {
  color: var(--color-elevated-text);
}

label:has(input[type=checkbox]), label:has(input[type=radio]) {
  white-space: nowrap;
}
label:has(input[type=checkbox]) input, label:has(input[type=checkbox]) .label-text, label:has(input[type=radio]) input, label:has(input[type=radio]) .label-text {
  vertical-align: middle;
}
label:has(input[type=checkbox]) .label-text, label:has(input[type=radio]) .label-text {
  cursor: default;
  margin-left: 0.5rem;
  text-align: left;
  white-space: normal;
  width: auto;
}

label:has(input[type=checkbox]:disabled) .label-text, label:has(input[type=radio]:disabled) .label-text {
  color: var(--color-base-text);
}

label:focus-within .label-text {
  color: var(--color-elevated-text);
  opacity: 1;
}

select {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0;
  -webkit-border-radius: 0;
}

textarea {
  font-size: 1rem;
  height: 4.6rem;
  line-height: 1.4rem;
  margin: 0;
  padding: 0.3rem 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/style/forms.scss"],"names":[],"mappings":"AACA;EACE,0CAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,8CAAA;EACA,eAAA;EACA,0DAAA;EACA,yBAAA;EACA,iBAAA;AAAF;AAEE;EACE,8CAAA;EACA,gCAAA;AAAJ;AAGE;EACE,iCAAA;EACA,iBAAA;AADJ;;AAKA;EACE,yCAAA;EACA,0BAAA;AAFF;AAIE;EACE,6CAAA;AAFJ;AAKE;EACE,6BAAA;AAHJ;;AAOA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,6BAAA;AAJF;;AAOA;EACE,SAAA;EACA,UAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;AAME;EACE,iCAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;;AASA;EACE,8BAAA;EACA,oBAAA;EACA,gBAAA;AANF;AAQE;EACE,gBAAA;AANJ;AAQE;EACE,cAAA;AANJ;;AAUA;EACE,YAAA;AAPF;;AAYC;EACG,6BAAA;EACA,qBAAA;EACA,iBAAA;AATJ;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,kBAAA;EACA,uBAAA;AAXF;;AAaA;EACE,iCAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;AAYE;EACE,sBAAA;AAVJ;AAYE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAVJ;;AAeE;EACE,6BAAA;AAZJ;;AAgBA;EACE,iCAAA;EACA,UAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,wBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AAbF","sourcesContent":["\nbutton, input, select, textarea, a.button {\n  border-color: var(--color-elevated-border);\n  color: var(--color-elevated-draw);\n  display: inline-block;\n  font-weight: normal;\n  line-height: var(--line-height);\n  padding: 0 0.6rem;\n  border-width: var(--border-width);\n  border-style: solid;\n  outline: none;\n  border-radius: 0;\n}\n\nbutton, a.button {\n  background-color: var(--color-elevated-border);\n  cursor: default;\n  height: calc(var(--line-height) + (2 * var(--border-width)));\n  -webkit-user-select: none;\n  user-select: none;\n\n  &:disabled {\n    background-color: var(--color-elevated-canvas);\n    opacity: var(--opacity-disabled);\n  }\n\n  &.confirming {\n    color: var(--color-elevated-warn);\n    font-weight: bold;\n  }\n}\n\ninput, select, textarea {\n  background-color: var(--color-base-input);\n  height: var(--line-height);\n\n  &:focus {\n    background-color: var(--color-elevated-input);\n  }\n\n  &::placeholder {\n    color: var(--color-base-hint);\n  }\n}\n\ninput[type=\"checkbox\"], input[type=\"radio\"] {\n  height: 1rem;\n  margin: 0;\n  min-width: unset;\n  padding: 0;\n  vertical-align: middle;\n  width: 1.1rem;\n}\n\ninput[type=\"number\"] {\n  padding-right: 0.4rem;\n}\n\n.chrome input[type=\"number\"] {\n  padding-right: 0;\n}\n\nselect:has(option:checked:disabled) {\n  color: var(--color-base-hint);\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nfieldset:has(input[type=\"checkbox\"]), fieldset:has(input[type=\"radio\"]) {\n  text-align: right;\n\n  legend.label-text {\n    color: var(--color-elevated-text);\n  }\n\n  label:not(:last-of-type) {\n    margin-right: 2rem;\n  }\n}\n\nfieldset:has(input[type=\"radio\"]) {\n  border: var(--border-elevated);\n  padding: 0.5rem 1rem;\n  text-align: left;\n\n  legend.label-text {\n    text-align: left;\n  }\n  label {\n    display: block;\n  }\n}\n\ninput[type=\"checkbox\"]:disabled, input[type=\"radio\"]:disabled {\n  opacity: 0.3;\n}\n\nlabel {\n\n .label-text {\n    color: var(--color-base-text);\n    display: inline-block;\n    text-align: right;\n  }\n}\n\n\nlabel:has(:disabled:not(option)) .label-text {\n  opacity: 0.5;\n}\n\nlabel:has(textarea) .label-text {\n  position: relative;\n  top: calc(0.3rem + 1px);\n}\nlabel:has(:checked):not(:has(select)) .label-text {\n  color: var(--color-elevated-text);\n}\n\nlabel:has(input[type=\"checkbox\"]), label:has(input[type=\"radio\"]) {\n  white-space: nowrap;\n\n  input, .label-text {\n    vertical-align: middle;\n  }\n  .label-text {\n    cursor: default;\n    margin-left: 0.5rem;\n    text-align: left;\n    white-space: normal;\n    width: auto;\n  }\n}\n\nlabel:has(input[type=\"checkbox\"]:disabled), label:has(input[type=\"radio\"]:disabled) {\n  .label-text {\n    color: var(--color-base-text);\n  }\n}\n\nlabel:focus-within .label-text {\n  color: var(--color-elevated-text);\n  opacity: 1;\n}\n\nselect {\n  appearance: none;\n  -webkit-appearance: none;\n  border-radius: 0;\n  -webkit-border-radius: 0;\n}\n\ntextarea {\n  font-size: 1rem;\n  height: 4.6rem;\n  line-height: 1.4rem;\n  margin: 0;\n  padding: 0.3rem 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
